import { i18n, useAlertDialog, useUgTag, UgEventTag } from "@bebit/store";
import { createGlobalState } from "@vueuse/core";
import { ref, computed } from "vue";
import env from "@host/env";

const GENERIC_ERROR_MESSAGE = i18n.global.t("utils.host.genericErrorMessage");

const { pushEvent } = useUgTag(env.ugTagMasterId);

export const globalErrorStore = createGlobalState(() => {
  const message = ref("");
  const hasError = computed(() => message.value !== "");
  const { openDialog, closeDialog } = useAlertDialog();

  async function clearError() {
    closeDialog();
    message.value = "";
  }

  async function setErrorMessage(errorMessage: string) {
    message.value = errorMessage;
  }

  function showError(errorMessage: string = GENERIC_ERROR_MESSAGE) {
    // FIXME: This function is temporary.
    pushEvent(UgEventTag.AlertDisplayed);
    openDialog();
    setErrorMessage(errorMessage);
  }

  return { message, hasError, clearError, setErrorMessage, showError };
});
